export default "__VITE_ASSET__BNyFmjnW__"